import { render, staticRenderFns } from "./DoubleVideo.vue?vue&type=template&id=6ee5eb56&"
import script from "./DoubleVideo.vue?vue&type=script&lang=js&"
export * from "./DoubleVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports